import { setLineDash } from 'gear';

import { Bounds, Frame } from 'cdl';

function stableLine(context, p0, p1 ) {
  context.beginPath();
  context.moveTo(p0.x,p0.y);
  context.lineTo(p1.x,p1.y);
  context.stroke();
}

export const DragSelectorHelper = function({ docPoint }, onEnd, strokeColor = '#006633' ) {
  this.onEnd = onEnd;
  this._pd = docPoint;
  this._fd = docPoint;
  this._sc = strokeColor;
};
DragSelectorHelper.prototype = {

  draw({ context, transform }) {

    const frame = Frame.fromBounds( this.bounds ).transformed(transform);

    // This is done piece by piece so the dash will be
    // more stable when dragging, the direction of each line
    // is important to make this trick work

    context.save();
    context.strokeStyle = this._sc;
    context.lineWidth = 1;
    setLineDash(context,[4,3]);

    stableLine( context, frame.p3, frame.p0 );
    stableLine( context, frame.p2, frame.p1 );
    stableLine( context, frame.p3, frame.p2 );
    stableLine( context, frame.p0, frame.p1 );
    context.restore();
  },

  move({ view, docPoint }) {
    this._pd = docPoint;
  },

  end(event) {
    const { onEnd } = this;
    onEnd(event,this.bounds);
  },

  get bounds() {
    return Bounds.ofPoints([this._pd,this._fd]);
  }
};



/** WEBPACK FOOTER **
 ** ./src/ui/tool/drag-selector.js
 **/